import { all, call, put, select, takeLatest } from 'redux-saga/effects';

import { currentCompany, notification } from '../../../actionTypes';
import dataProvider from '../../../store/dataProvider';
import { updateFiles } from '../../file/updateFiles';
import { uploadSelector } from '../../../utils/pageHelpers';

export function* update({ payload: { companyId, financialInfo, financialArrays, sectionKey } }) {
  try {
    const { uploadKeys, ...dirtyValues } = financialInfo;
    const formValues = Object.keys(dirtyValues).reduce(
      (acc, item) => (uploadKeys.includes(item) ? acc : { ...acc, [item]: dirtyValues[item] }),
      {},
    );

    // update files
    if (uploadKeys.length) {
      yield all(
        uploadKeys.map(
          key =>
            (financialInfo[key].createList.length || financialInfo[key].deleteList.length) &&
            call(updateFiles, {
              companyId,
              deleteList: financialInfo[key].deleteList,
              createList: financialInfo[key].createList,
              sectionKey: key,
            }),
        ),
      );
    }

    const fileObj = yield select(store => uploadSelector(store, uploadKeys));

    const updateFinInfo = yield call(dataProvider.updateOnly, `companies/${companyId}/fin-info`, formValues);
    const updateFinArrays = yield call(
      dataProvider.createList,
      `companies/${companyId}/annual-dollar-volume`,
      financialArrays,
    );

    yield put({
      type: currentCompany.finInfo.update.end,
      payload: {
        financialInfo: { ...updateFinInfo.data, ...fileObj, uploadKeys },
        financialArrays: updateFinArrays.data || [],
      },
    });

    // update PQF document validation
    yield put({
      type: currentCompany.companyInfo.validation.start,
      payload: { companyId: companyId, validationKey: sectionKey },
    });
  } catch (e) {
    yield put({ type: currentCompany.finInfo.update.error });
    yield put({ type: notification.add, payload: { error: e.message } });
  }
}

export default function* getFinInfoSaga() {
  yield takeLatest(currentCompany.finInfo.update.start, update);
}
